import { Flex } from '@chakra-ui/react';
import { OutlineCard } from '@morressier/alembic';
import { FormFieldFocusSelect } from '@publishing-engine/domain/types/article';
import { FocusIssueSelect } from 'src/components/Submission/GenericFieldComponents/Select/FocusIssueSelect';

const FocusIssue = ({
  config,
  guidelineLink
}: {
  config: FormFieldFocusSelect;
  guidelineLink?: string;
}) => (
  <Flex flexDirection="column" gap={8} width="100%">
    <OutlineCard padding={4}>
      <FocusIssueSelect config={config} guidelineLink={guidelineLink} />
    </OutlineCard>
  </Flex>
);

export default FocusIssue;
